<template>
    <footer class="fs-footer">
        <v-container>
            <div class="fs-footer-area fs-footer-area-desktop">
                <div class="fs-footer-section">
                    <h3 class="fs-footer-title">{{ t('footer.help_title') }}</h3>
                    <div class="fs-footer-content">
                        <p>
                            {{ t('footer.call_center') }}
                            <a href="tel:+40219978" class="fs-footer-link">+4021 9978</a>
                        </p>
                        <p>
                            {{ t('footer.email') }}
                            <a href="mailto:supervisor@tarom.ro" class="fs-footer-link">supervisor@tarom.ro</a>
                        </p>
                        <p>{{ t('footer.schedule') }}</p>
                    </div>
                </div>
                <div class="fs-footer-section">
                    <h3 class="fs-footer-title">{{ t('footer.legal_title') }}</h3>
                    <div class="fs-footer-content">
                        <a
                            :href="termsTravelUrl"
                            class="fs-footer-link"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {{ t('footer.terms_travel') }}
                        </a>
                        <a
                            :href="termsBookingUrl"
                            class="fs-footer-link"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {{ t('footer.terms_booking') }}
                        </a>
                        <a
                            :href="privacyPolicyUrl"
                            class="fs-footer-link"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {{ t('footer.privacy_policy') }}
                        </a>
                    </div>
                </div>
            </div>
            <div class="fs-footer-area fs-footer-area-mobile">
                <div class="fs-footer-section">
                    <v-expansion-panels>
                        <v-expansion-panel>
                            <v-expansion-panel-title>
                                <h3 class="fs-footer-title">{{ t('footer.help_title') }}</h3>
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div class="fs-footer-content">
                                    <p>
                                        {{ t('footer.call_center') }}
                                        <a href="tel:+40219978" class="fs-footer-link">+4021 9978</a>
                                    </p>
                                    <p>
                                        {{ t('footer.email') }}
                                        <a href="mailto:supervisor@tarom.ro" class="fs-footer-link">supervisor@tarom.ro</a>
                                    </p>
                                    <p>{{ t('footer.schedule') }}</p>
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
                <div class="fs-footer-section">
                    <v-expansion-panels>
                        <v-expansion-panel>
                            <v-expansion-panel-title>
                                <h3 class="fs-footer-title">{{ t('footer.legal_title') }}</h3>
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <div class="fs-footer-content">
                                    <a
                                        :href="termsTravelUrl"
                                        class="fs-footer-link"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {{ t('footer.terms_travel') }}
                                    </a>
                                    <a
                            :href="termsBookingUrl"
                            class="fs-footer-link"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {{ t('footer.terms_booking') }}
                        </a>
                                    <a
                            :href="privacyPolicyUrl"
                            class="fs-footer-link"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {{ t('footer.privacy_policy') }}
                        </a>
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>
            </div>
        </v-container>
    </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t, locale } = useI18n();

const termsTravelUrl = computed(() => {
    switch (locale.value) {
        case 'en':
            return 'https://www.tarom.ro/en/travelling-terms-and-conditions/';
        case 'fr':
            return 'https://www.tarom.ro/fr/termes-et-conditions-de-voyage/';
        case 'it':
            return 'https://www.tarom.ro/it/termeni-e-condizioni-di-viaggio/';
        case 'de':
            return 'https://www.tarom.ro/de/geschaefts-und-reisebedingungen/';
        case 'es':
            return 'https://www.tarom.ro/es/terminos-y-condiciones-de-viaje/';
        default:
            // default to Romanian
            return 'https://www.tarom.ro/termeni-si-conditii-de-calatorie/';
    }
});

const termsBookingUrl = computed(() => {
    switch (locale.value) {
        case 'en':
            return 'https://www.tarom.ro/en/terms-and-conditions-online-reservations/';
        case 'fr':
            return 'https://www.tarom.ro/fr/termes-et-conditions-pour-des-reservations-en-ligne/';
        case 'it':
            return 'https://www.tarom.ro/it/termini-e-condizioni-prenotazione-online/';
        case 'de':
            return 'https://www.tarom.ro/de/allgemeine-bedingungen-fur-die-online-buchung/';
        case 'es':
            return 'https://www.tarom.ro/es/terminos-y-condiciones-para-reservas-en-linea/';
        default:
            // default to Romanian
            return 'https://www.tarom.ro/termeni-si-conditii-pentru-rezervari-online/';
    }
});

const privacyPolicyUrl = computed(() => {
    switch (locale.value) {
        case 'en':
            return 'https://www.tarom.ro/en/privacy-policy/';
        case 'fr':
            return 'https://www.tarom.ro/fr/politique-de-confidentialite/';
        case 'it':
            return 'https://www.tarom.ro/it/politica-di-confidenzialita/';
        case 'de':
            return 'https://www.tarom.ro/de/vertraulichkeitspolitik/';
        case 'es':
            return 'https://www.tarom.ro/es/politica-de-privacidad/';
        default:
            // default to Romanian
            return 'https://www.tarom.ro/politica-de-confidentialitate/';
    }
});
</script>
